import { Breakpoint, getBreakpoint } from 'bloko/common/media';

import Components from 'HHC/Components';

export default Components.build({
    create(_, params) {
        if (window.top !== window || getBreakpoint() === Breakpoint.XS || window.globalVars.isWebView) {
            return;
        }

        window.requestIdleCallback(() => {
            const script = document.createElement('script');
            const iid = 'uriid_da39a3ee5e6b4b0d3255bfef95601890afd80709';
            const scriptId = params.userType === 'employer' ? 12 : 114;
            script.setAttribute('id', 'UR_initiator');
            script.setAttribute('src', `//feedback.hh.ru/public/sdk/chat-${iid}-${scriptId}.js`);
            script.setAttribute('defer', 'defer');

            if (params.isEmployer) {
                script.addEventListener('load', () => {
                    window.UR.userConfig({
                        token: params.secretHash,
                        userEmail: params.email,
                        userName: params.name,
                        properties: {
                            property_178: params.employerId,

                            property_371: 'ZP',
                        },
                    });
                });
            }
            document.body.appendChild(script);

            const zarplataSupportChatAppearCallback = (mutationsList, observer) => {
                const handleZpNode = (node) => {
                    node.classList.add('zarplata-support-chat-launcher');
                    node.dataset.qa = 'zp-support-chat';

                    window.dispatchEvent(new CustomEvent('UR_chatElement-Added'));

                    observer.disconnect();
                };
                mutationsList.forEach((mutation) => {
                    const addedNode = mutation.addedNodes[0];

                    if (
                        !params.isEmployer &&
                        addedNode?.classList.contains('UR_chatElement') &&
                        addedNode?.classList.contains('UR_chatHandleTab')
                    ) {
                        handleZpNode(addedNode);
                    }

                    if (params.isEmployer && addedNode?.classList.contains('UR_chatElement')) {
                        handleZpNode(addedNode);
                    }
                });
            };

            const zarplataSupportChatAppearObserver = new MutationObserver(zarplataSupportChatAppearCallback);
            zarplataSupportChatAppearObserver.observe(document.body, { childList: true });
        });
    },
});
